export default "__VITE_ASSET__DjXoRhts__"